import type { CalendarProject } from '../types/calendarProject';
import type { AssetUploadPlan } from '../types/assetStorage';

const requiredEndpoints = [
  'POST /api/assets/create-upload-session',
  'PUT signed R2 upload URL',
  'POST /api/assets/complete-upload',
  'GET /api/assets/:assetId',
  'DELETE /api/assets/:assetId',
];

export interface CloudAssetAdapter {
  createUploadPlan(project: CalendarProject): AssetUploadPlan;
  isConfigured(): boolean;
  getRequiredEndpoints(): string[];
  explainMissingConfiguration(): string[];
}

export const mockCloudAssetAdapter: CloudAssetAdapter = {
  createUploadPlan(project) {
    return {
      projectId: project.id,
      storageMode: 'cloud-r2-planned',
      expectedAssetCount: project.photos.length,
      estimatedTotalBytes: project.photos.reduce((sum, photo) => sum + photo.sizeBytes, 0),
      acceptedMimeTypes: ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'],
      maxSingleFileBytes: 50 * 1024 * 1024,
      maxProjectBytes: 2 * 1024 * 1024 * 1024,
      targetProvider: 'cloudflare-r2',
      requiredEndpoints,
    };
  },
  isConfigured() {
    return false;
  },
  getRequiredEndpoints() {
    return [...requiredEndpoints];
  },
  explainMissingConfiguration() {
    return [
      'Cloud upload bude aktivní až po přidání Worker API a R2 konfigurace.',
      'V MVP se neprovádí žádný network upload originálních fotek.',
      'Chybí endpointy pro vytvoření upload session, signed URL, dokončení uploadu a správu assetů.',
    ];
  },
};
